import _upperFirst from 'lodash/upperFirst';
import { switchPlanNameIfNeeded } from '../Administer/helpers';

// Builds a CSV from scoreAverages (planName > timepoint > domain > pawnId)
export const downloadCSV = (scoreAverages, allAnswerData, filename) => {
    if (!scoreAverages || !allAnswerData) return;

    const domains = Object.keys(allAnswerData).filter(k => k !== 'feedback');

    // Build respondentMap by pawnId
    const respondentMap = {};
    Object.entries(scoreAverages).forEach(([planName, timepointData]) => {
        Object.entries(timepointData).forEach(([timepoint, domainData]) => {
            Object.entries(domainData).forEach(([domain, pawnData]) => {
                Object.entries(pawnData).forEach(([pawnId, entry]) => {
                    if (!respondentMap[pawnId]) {
                        respondentMap[pawnId] = {
                            pawnId,
                            role: entry.role,
                            firstName: entry.pawn.fields?.firstName ?? '',
                            lastName: entry.pawn.fields?.lastName ?? '',
                            wrapId: entry.pawn.fields?.wrapId ?? '',
                            planName,
                            timepoint,
                            domains: {},
                            responseDate: entry.responseDate ? entry.responseDate.split(' ')[0] : '',
                        };
                    }
                    if (!respondentMap[pawnId].domains[domain]) {
                        respondentMap[pawnId].domains[domain] = { sum: 0, count: 0 };
                    }
                    respondentMap[pawnId].domains[domain].sum += entry.sum || 0;
                    respondentMap[pawnId].domains[domain].count += entry.numberOfQuestionsAnswered || 0;
                });
            });
        });
    });

    const escapeCell = val => `"${String(val ?? '').replace(/"/g, '""')}"`;
    const headers = [
        'Role',
        'First Name',
        'Last Name',
        'Wrap ID',
        'Plan Name',
        'Timepoint',
        'Response Date',
        ...domains.map(domain => `${_upperFirst(domain)} Score`),
    ];
    const rows = Object.values(respondentMap).map(respondent => {
        const domainScores = domains.map(domain => {
            const d = respondent.domains[domain];
            if (!d || d.count === 0) return '';
            return (d.sum / d.count).toFixed(2);
        });
        return [
            respondent.role,
            respondent.firstName,
            respondent.lastName,
            respondent.wrapId,
            switchPlanNameIfNeeded(respondent.planName),
            respondent.timepoint,
            respondent.responseDate,
            ...domainScores,
        ]
            .map(escapeCell)
            .join(',');
    });

    const csvString = [headers.map(escapeCell).join(','), ...rows].join('\n');
    const blob = new Blob([csvString], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};
